import type { MatchDayDetail, Player, PlayerId } from '../api/types';

/* Who actually played, derived from the Matches rather than from the participant list: a
   Participant with `tookPart: false` scored without playing (CONTEXT.md) and should not be
   pre-selected for the next Match Day. */
export const playedIn = (matchDay: MatchDayDetail): Set<PlayerId> => {
  const played = new Set<PlayerId>();
  matchDay.matches.forEach((match) => {
    played.add(match.player1);
    played.add(match.player2);
  });
  return played;
};

/* The same four to six people play most weeks, so last Match Day's line-up is a far better
   default than every active Player. Falls back to everyone when there is no history, or when
   nobody from last time is still active — an empty list would be a worse default than a
   wrong one. */
export function defaultParticipants(
  active: Player[],
  previous: MatchDayDetail | null
): Player[] {
  if (!previous) {
    return active;
  }
  const played = playedIn(previous);
  const carried = active.filter((player) => played.has(player._id));
  return carried.length > 0 ? carried : active;
}
